var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('loginOut.loggedOutText')))]),_c('router-link',{attrs:{"to":"/portal/login"}},[_vm._v(_vm._s(_vm.$t('loginOut.loginButton')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }